import yup from '../../utils/yup';

export default yup.object().shape({
    eventName: yup.string().trim().max(100).required(),
  email: yup.string().email().required()
});